interface ModalProps {
    color?: string;
}

export const DoubleRightArrow = (props: ModalProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
            <path d="M1 11.5L6 6.5L1 1.5M8 11.5L13 6.5L8 1.5" stroke={props.color ? props.color : "#EB3D00"} strokeOpacity="0.5"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}